<template>
  <div v-show="show">
    <div class="px-4 pb-2 text-white text-sm">
      <table class="table-base table-borderless mb-0 text-xs text-white">
        <tbody>
          <tr v-if="getActualMix?.showBasePercent">
            <td class="px-1 pt-1 pb-0 font-medium">
              {{ getActualMix?.basePercent.toFixed(2) }}%
            </td>
            <td class="px-1 pt-1 pb-0 font-medium text-right">
              {{ t('basis') }}
            </td>
          </tr>
          <tr>
            <td class="px-1 pt-1 pb-0 font-medium">
              {{ getActualMix?.itemsPercent.toFixed(2) }}%
            </td>
            <td class="px-1 pt-1 pb-0 font-medium text-right">
              {{ t('additive') }}
            </td>
          </tr>
          <tr v-if="getActualMix?.showBaseExtendedItemsPercent">
            <td class="px-1 pt-1 pb-0">
              {{ getActualMix?.baseExtendedItemsPercent.toFixed(2) }}%
            </td>
            <td class="px-1 pt-1 pb-0 text-right">
              {{ t('extended_basis') }}
            </td>
          </tr>
          <tr v-if="getActualMix?.showDryFruitItemsPercent">
            <td class="px-1 pt-1 pb-0">
              {{ getActualMix?.dryFruitItemsPercent.toFixed(2) }}%
            </td>
            <td class="px-1 pt-1 pb-0 text-right">
              {{ t('fruit') }}
            </td>
          </tr>
          <tr v-if="getActualMix?.showNutItemsPercent">
            <td class="px-1 pt-1 pb-0">
              {{ getActualMix?.nutItemsPercent.toFixed(2) }}%
            </td>
            <td class="px-1 pt-1 pb-0 text-right">
              {{ t('nuts') }}
            </td>
          </tr>
          <tr v-if="getActualMix?.showOnTopItemsPercent">
            <td class="px-1 pt-1 pb-0">
              {{ getActualMix?.onTopItemsPercent.toFixed(2) }}%
            </td>
            <td class="px-1 pt-1 pb-0 text-right">
              {{ t('extra') }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'

import { useMixStore } from '@/stores/MixStore'

const mixStore = useMixStore()
const { getActualMix } = storeToRefs(mixStore)

defineProps({
  show: {
    type: Boolean,
    default: false,
  },
})

const { t } = useI18n()
</script>

<i18n>
  {
    "cs": {
    "additive": "PŘÍSAD",
    "basis": "ZÁKLADU",
    "extended_basis": "ROZŠÍŘENÉHO ZÁKLADU",
    "extra": "NĚCO NAVÍC",
    "fruit": "OVOCE",
    "nuts": "Ořechy"
},
    "sk": {
    "additive": "PRÍSAD",
    "basis": "ZÁKLADU",
    "extended_basis": "ROZŠÍRENÉHO ZÁKLADU",
    "extra": "NIEČO NAVYŠE",
    "fruit": "OVOCIE",
    "nuts": "Orechy"
},
    "pl": {
    "additive": "DODATKÓW",
    "basis": "PODSTAWY",
    "extended_basis": "rozszerzenia podstawy",
    "extra": "innych",
    "fruit": "owoców",
    "nuts": "Orzechy"
},
    "hu": {
    "additive": "Adalék",
    "basis": "ALAP",
    "extended_basis": "MÜZLIALAP KIBŐVÍTÉSE",
    "extra": "VALAMI PLUSZ",
    "fruit": "GYÜMÖLCS",
    "nuts": "Diófélék"
},
    "de": {
    "additive": "Basis erweitern",
    "basis": "BASIS",
    "extended_basis": "ERWEITERTE BASIS",
    "extra": "ETWAS EXTRA",
    "fruit": "OBST",
    "nuts": "Nüsse"
},
    "at": {
    "additive": "Basis erweitern",
    "basis": "BASIS",
    "extended_basis": "ERWEITERTE BASIS",
    "extra": "ETWAS EXTRA",
    "fruit": "OBST",
    "nuts": "Nüsse"
},
    "ro": {
    "additive": "Adaos",
    "basis": "BAZA",
    "extended_basis": "COMPLETEAZĂ BAZA",
    "extra": "CEVA ÎN PLUS",
    "fruit": "FRUCTE",
    "nuts": "Nuci"
},
    "fr": {
    "additive": "INGRÉDIENTS",
    "basis": "BASE",
    "extended_basis": "BASE ENRICHIE",
    "extra": "QUELQUE CHOSE DE PLUS",
    "fruit": "FRUIT",
    "nuts": "Fruits à coque"
}
  }
</i18n>
